import { Avatar, Box, Button, Link as MuiLink, Typography } from '@mui/material';
import NavBar from '../NavBar';
import { Link } from 'react-router-dom';
import { FaRegCircleUser } from 'react-icons/fa6';
import { header_content } from '../../../../../data/general_texts';
import ImageNavigation from '../ImageNavigation';
import { useAuth } from '../../../../../contexts/AuthProvider';
import { getGreetingInitial, getGreetingName } from '../../partnerNav';
import NotificationsBell from '../NotificationsBell';

const MainLinksDesktop = ({ onSignOut }) => {
    const { isAuthenticated, user, userName } = useAuth();
    const greetName = getGreetingName(user, userName);

    return (
        <Box sx={styles.main_links}>
            <ImageNavigation />
            <NavBar />
            {isAuthenticated ? (
                <Box sx={styles.account}>
                    <NotificationsBell />
                    <MuiLink component={Link} to="/meu-perfil" sx={styles.profileLink}>
                        <Typography component="span" sx={styles.greeting}>
                            Olá, {greetName}
                        </Typography>
                        <Avatar
                            src={user?.image || undefined}
                            alt={greetName}
                            sx={styles.avatar}
                        >
                            {getGreetingInitial(greetName)}
                        </Avatar>
                    </MuiLink>
                    <Button onClick={onSignOut} sx={styles.signOut}>
                        Sair
                    </Button>
                </Box>
            ) : (
                <MuiLink sx={styles.login} component={Link} to="/login">
                    {header_content.auth_content.text}
                    <Box component={FaRegCircleUser} sx={{ ml: 1, fontSize: '1.05rem' }} />
                </MuiLink>
            )}
        </Box>
    );
};

const styles = {
    main_links: {
        display: {
            xs: 'none',
            md: 'grid',
        },
        gridTemplateColumns: 'auto 1fr auto',
        alignItems: 'center',
        columnGap: 2,
        minHeight: '4.25rem',
    },
    account: {
        display: 'flex',
        alignItems: 'center',
        gap: 1.25,
        justifySelf: 'end',
    },
    profileLink: {
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        color: 'common.white',
        '&:hover': {
            color: 'secondary.main',
        },
    },
    greeting: {
        color: 'inherit',
        fontSize: '0.8125rem',
        fontWeight: 500,
        whiteSpace: 'nowrap',
    },
    avatar: {
        width: 32,
        height: 32,
        fontSize: '0.75rem',
        fontWeight: 600,
        bgcolor: 'secondary.main',
        color: 'primary.main',
    },
    signOut: {
        color: 'secondary.main',
        p: '0 !important',
        minWidth: 0,
        fontSize: '0.8125rem',
        fontWeight: 600,
        letterSpacing: '0.04em',
        '&:hover': {
            color: 'secondary.dark',
            bgcolor: 'transparent',
        },
    },
    login: {
        color: 'common.white',
        display: 'flex',
        alignItems: 'center',
        fontSize: '0.8125rem',
        fontWeight: 500,
        whiteSpace: 'nowrap',
        justifySelf: 'end',
        '&:hover': {
            color: 'secondary.main',
        },
    },
};

export default MainLinksDesktop;
